import _ from '@/lib/lodash';
import { MomentSetup } from '@/lib/moment';
import { AlertSetup } from '@/lib/alert';
import { ConfirmSetup } from '@/lib/confirm';

export function miscSetup(app, config) { 
  app.config.globalProperties.$_ = _;

  window.intercomSettings = config.intercomSettings;
  
  app.config.globalProperties.$set = (item, key, value) => {
    item[key] = value;
  
    // console.trace('$set is deleted from vue 3!')
  };
  
  app.config.globalProperties.$delete = (item, key) => {
    if(Array.isArray(item)) { 
      item.splice(key, 1);
    } else if(typeof item === 'object' && item !== null) {
      delete item[key];
    }
  
    // console.trace('$delete is deleted from vue 3!')
  };

  app.use(MomentSetup);
  app.use(AlertSetup);
  app.use(ConfirmSetup);
}